/*
 * (辉哥 9/17 18:59 派 Coder/Mavis 修 r.18f 仍 FAIL):
 * DiscussionComposer extend: 加 hero image 上传按钮 + data().heroImageUrl 字段
 *
 * 真因 (辉哥 9/17 18:59 反馈 r.18f 仍 FAIL, 登录后 composer 没按钮 + 未登录点发帖报错):
 *   - r.18f 用了 `app.initializers.add` 包裹 callback + flarum.reg.get/onLoad 双层兜底
 *     编译后: `if (e = window.flarum.reg.get(...)), !e` 逗号运算符逻辑错误
 *     callback 跑一次,如果 boot 时 DiscussionComposer 没 ready → return + onLoad
 *     onLoad 异步,但 registerComposerExtends 在 return 之后不会跑
 *     → boot 时可能 silent skip (跟 r.18e 同样问题)
 *   - 未登录点发帖报错: 可能 callback 在 DiscussionComposer 没 ready 时跑, 触发 silent skip
 *
 * 修法 (r.18g, Mavis 18:59 修, 跟 PhoneLogin/SignUp/ForgotPassword 同款 pattern):
 *   - 不用 app.initializers.add 包裹
 *   - 顶层直接 `flarum.reg.onLoad(...)` 或 sync `flarum.reg.get(...)`
 *   - PhoneLogin.js L50-65 已经在用同款 onLoad pattern, ziven-core 实战验证过
 *
 * 模式 (vendor Flarum 2.0):
 *   - DiscussionComposer 类是 Form 组件 (extends ComposerBody → Modal → Form)
 *   - vendor ComposerBody.tsx L89 `headerItems() { return new ItemList(); }`
 *   - vendor DiscussionComposer.js L44 override headerItems() 加 title / discussionTitle
 *   - 我们在 headerItems() add HeroImageUpload 组件
 *   - composer.state.heroImageUrl 保存当前选中的 CDN URL
 *   - composer.data() 返 { title, content, heroImageUrl }
 *   - 提交时 DiscussionResource create endpoint 接收 heroImageUrl 写入 discussion.hero_image_url
 *
 * ziven-core extend:
 *   - 在 composer header (标题输入框下方) 加 HeroImageUpload 组件
 *   - Admin + Mods 默认有 discussion.ziven-core.uploadHeroImage 权限才显示
 *   - 普通用户 composer 不显示 (辉哥 SOP)
 */

import app from 'flarum/forum/app';
import HeroImageUpload from './components/HeroImageUpload';
function safeExtend(targetOrClass, method, fn) {
  if (!window.__zivenCoreSafeExtend) {
    console.warn('[ziven-core] safeExtend helper not loaded, skipped:', method);
    return null;
  }
  return window.__zivenCoreSafeExtend(targetOrClass, method, fn);
}
export default function modifyDiscussionComposer() {
  // (辉哥 9/17 18:59 反馈 r.18f 仍 FAIL 修):
  //   跟 PhoneLogin.js / SignUp.js / ForgotPassword.js 同款 flarum.reg.onLoad pattern
  //   (ziven-core 实战验证过 lazy module extend), 不用 app.initializers.add 包裹
  const flarumReg = typeof window !== 'undefined' && window.flarum && window.flarum.reg;
  if (!flarumReg) {
    console.error('[ziven-core] modifyDiscussionComposer: flarum.reg not available, skip extends');
    return;
  }

  // sync 先试一次 (模块已注册场景)
  const syncComposer = flarumReg.get('core', 'forum/components/DiscussionComposer');
  if (syncComposer) {
    registerComposerExtends(syncComposer);
    return;
  }

  // async 等模块 ready
  flarumReg.onLoad('core', 'forum/components/DiscussionComposer', function (DiscussionComposer) {
    if (!DiscussionComposer) {
      console.warn('[ziven-core] DiscussionComposer onLoad returned undefined, skip extends');
      return;
    }
    registerComposerExtends(DiscussionComposer);
  });
}
function registerComposerExtends(DiscussionComposer) {
  if (!DiscussionComposer) {
    console.warn('[ziven-core] DiscussionComposer undefined, skip extends');
    return;
  }

  // 1) extend data() — 把 heroImageUrl 加进提交 payload
  // r.18l (22:21 辉哥 9/17 22:21 拍板修, ComposerState 路径错位真因):
  //   之前 r.18 写的 this.composer.state.heroImageUrl 永远 undefined —
  //   vendor flarum/core/js/src/forum/states/ComposerState.tsx L72
  //   `public fields!: Record<string, Stream<any>>` 才是 ComposerState 的字段存储
  //   `state` 属性在 ComposerState 上**不存在**, 永远 undefined
  //   → data() extend 永远读不到 heroImageUrl, 提交 payload 没这个字段
  //   → callback 写 this.composer.state.heroImageUrl = url silent fail (state undefined)
  //   → 辉哥 9/17 22:13 反馈 "探针 undefined" 的真因 (第二真因, 第一真因是 HeroImageCropModal onApply this.props.onUpload 漏改 r.18l 第一稿已修)
  safeExtend(DiscussionComposer, 'data', function (original) {
    return function () {
      const data = original();
      // ComposerState.fields (不是 .state) — 看 vendor ComposerState.tsx L72
      const heroImageUrl = this.composer && this.composer.fields && this.composer.fields.heroImageUrl || null;
      if (heroImageUrl) {
        data.heroImageUrl = heroImageUrl;
      }
      return data;
    };
  });

  // 2) extend headerItems() — 在 composer header 加 HeroImageUpload
  // 真因: vendor Flarum 2.0 DiscussionComposer 用 headerItems() 不是 items()
  // 真因 (辉哥 9/17 19:07 反馈 r.18f 仍 FAIL): actor.attribute('permissions') 永远 undefined
  //   Flarum 2.0 API /api/users/:id 返回 attrs 是 canEdit/canDelete/canEditBio 等 can* 字段, 没 permissions array
  //   修法: 用 actor.id() + actor.groups() 检查 Admin (group_id=1) / Mods (group_id=4)
  // (辉哥 9/17 21:47 反馈 mobile+desktop composer 都看不到按钮):
  //   真因: Flarum 2.0 Model.id(): string | undefined (Model.ts L85), Group.id() 返 string "1" 不是 number 1
  //   r.18g 写的 `1 === t || 4 === t` (number === string) 永远 false → canUpload 永远 false → 按钮永远不 add
  //   辉哥账号 id=2 + groups ["1", "11"] 全被过滤, Admin/Mods/所有人 composer 都看不到上传头图入口
  //   修法: 改成 string 强等 `'1' === gid || '4' === gid` (Group.id() 确定返 string, 无需 String() 转换)
  const ADMIN_GROUP_IDS = ['1', '4'];
  safeExtend(DiscussionComposer, 'headerItems', function (items) {
    // 修: Flarum 2.0 login 后 app.session.user 一直 null, 只 set app.session.userId
    //   兜底: `app.session.user || app.store.getById('users', app.session.userId)`
    const actor = app.session.user || app.session.userId && app.store.getById('users', app.session.userId);
    if (!actor) return;

    // 真因修: Flarum 2.0 没 permissions attribute, 用 groups check
    //   Admin (group_id=1) + Mods (group_id=4) 默认有 uploadHeroImage 权限 (PHP migration seed)
    //   普通用户 groups 不含 1 或 4 → canUpload false → 按钮隐藏
    // 修: Flarum 2.0 Group.id() 返 string "1" 不是 number 1
    //   Model.ts L85 `id(): string | undefined`, 必须用 string 强等
    let canUpload = false;
    if (typeof actor.id === 'function' && actor.id() === '1') {
      // 主超管 (id="1" string) 永远允许 (r.18i 修: user id 也是 string)
      canUpload = true;
    } else if (typeof actor.groups === 'function') {
      const groupList = actor.groups() || [];
      canUpload = groupList.some(g => {
        const gid = typeof g === 'object' && g.id ? g.id() : g;
        return ADMIN_GROUP_IDS.indexOf(String(gid)) >= 0;
      });
    } else if (actor.attribute && actor.attribute('isAdmin')) {
      canUpload = true;
    }
    if (!canUpload) return;
    items.add('heroImage', m(HeroImageUpload, {
      key: "heroImage"
      // r.18l (22:21): ComposerState.fields (不是 .state) — 看 vendor ComposerState.tsx L72
      ,
      value: this.composer && this.composer.fields && this.composer.fields.heroImageUrl || null,
      onChange: url => {
        // r.18l (22:21): ComposerState.fields (不是 .state) — silent fail 修
        if (this.composer && this.composer.fields) {
          this.composer.fields.heroImageUrl = url;
        }
        m.redraw();
      }
    }), 50 // 优先级: 50, 比 title (默认 100 低) 之前
    );
  });
}